import Cookies from "universal-cookie";
import { post, put } from "axios";

import { getApiAsyn, deleteApi, baseUrl, basePYUrl } from "../../PostAPI";
import { handleAPIError, APIError } from "../../common/errorHandler";
import { API_URL } from "../../../constants/urlConstants";
import { extractData } from "../../utils";
import { generateImageUrl, getDecoratedUrl } from "../../common/urlService";
import { asyncForEach } from "../../../utils/async";
import { getAllAttachment } from "../commonService";

const cookies = new Cookies();

const dataUploadApi = (url, data, isEdit = false) => {
 const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: cookies.get("authorization"),
    },
  };
  if (isEdit) {
    return put(basePYUrl + url, data, config);
  } else {
    return post(basePYUrl + url, data, config);
  }
};
export const fetchCompany = async (payload) => {
  const url = API_URL.PROFILE.FETCH_USER_COMPANY_INFO;
  try {
    let result = await getApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }

    return extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
export const fetchCustomers = async (payload) => {
  const { id } = payload;
  const url = API_URL.PROFILE.FETCH_CUSTOMER_INFO.replace(":id", id);

  try {
    let result = await getApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }
    return extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
export const createCompany = async (payload) => {
  const url = API_URL.COMPANY.CREATE;
  try {
    let result = await dataUploadApi(url, payload.data, false);
      if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
